import { render, staticRenderFns } from "./DraftListDetail.vue?vue&type=template&id=461756d5"
import script from "./DraftListDetail.vue?vue&type=script&lang=js"
export * from "./DraftListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports